import { Check } from 'lucide-react';

/**
 * VerifiedBadge component - Displays verification status for products
 * 
 * Features:
 * - Checkmark icon + "Verified" text
 * - Success color styling (#00AA44)
 * - Accessible ARIA label
 */
export const VerifiedBadge = () => {
  return (
    <div
      className="inline-flex items-center gap-1 px-2 py-1 bg-success/10 text-success rounded-md text-small font-medium"
      aria-label="Verified product"
      role="status"
    >
      <Check className="w-4 h-4" aria-hidden="true" />
      <span>Verified</span>
    </div>
  );
};

